<template>
  <div class="mt-4 mb-5">
    <v-data-table
      dense
      :headers="headers"
      :items="products"
      disable-pagination
      hide-default-footer
      class="elevation-0"
      item-key="id">
      <template v-slot:item.price="{ item }">
        <div  class="text-right">
          {{formatAngka(item.price)}}
        </div>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
        <div  class="text-right">
          <v-btn v-if="item.sudahada===1" disabled small dark text @click.native="tambahprodukmapping(item)" class="grey ma-2">
            Tambah ke daftar Produk
          </v-btn>
          <v-btn v-else  small dark text @click.native="tambahprodukmapping(item)" class="green ma-2">
            Tambah ke daftar Produk
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import { mapActions } from 'vuex'

export default {
  name: 'TableProductSeller',
  props: [
    'products'
  ],
  data: () => ({
    abu: 'grey',
    ijo: 'green',
    headers: [
      {
        text: 'Produk',
        value: 'productname',
        sortable: false
      },
      {
        text: 'Kode',
        value: 'productcode',
        sortable: false
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false
      },
      {
        text: 'Harga',
        value: 'price',
        sortable: false
      },
      {
        text: 'Aksi',
        value: 'aksi',
        sortable: false
      }
    ]
  }),
  computed: {
  },
  methods: {
    ...mapActions('ProductMapping', ['addProductmapping']),
    colorStatus (val) {
      if (parseInt(val) === 1) {
        return 'green'
      } else {
        return 'red'
      }
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Open'
      } else {
        return 'Close'
      }
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    tambahprodukmapping (item) {
      console.log(item)
      this.$confirm('Yakin akan Tambahkan ' + item.productname, { color: 'green', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          var a = {
            productmemberid: item.id,
            status: 1,
            prioritas: 0,
            sellerid: this.$route.params.id
          }
          this.addProductmapping(a)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
